export const SESSION_CREATE  = 'SESSION_CREATE';

export const SESSION_DESTROY = 'SESSION_DESTROY';



// WEBPACK FOOTER //
// ./app/constants/sessionTypes.js